import React from 'react';
import useAuthImage from '../hooks/useAuthImage';

/**
 * An <img> that fetches its source via an authenticated API call.
 * Accepts the same props as a regular <img>, plus reportId and filename.
 *
 * `localUrl` short-circuits the fetch: a photo shot offline is not on the
 * server yet, so it is displayed straight from its local object URL until the
 * queued upload goes through.
 */
export default function AuthImage({ reportId, filename, alt, localUrl, ...props }) {
  const fetched = useAuthImage(reportId, localUrl ? '' : filename);
  const src = localUrl || fetched;

  if (!src) {
    return null;
  }

  return <img src={src} alt={alt} {...props} />;
}
